const NoMatch = () => <div>400</div>

export default NoMatch
